import type { Catalogs, Translation } from "@amtana/i18n";

// The framework's own words: what a screen says when it fails to load, and the
// copy for the codes every contract shares (packages/module ADR-001, point 2).
// One key per string, in English and Spanish.

export type BrowserCatalog = typeof EN;

const EN = {
  tryAgain: "Try again",
  pageDidNotLoad: "This page did not load",
  appDidNotLoad: "{product} did not load",
  reference: "Reference {reference}",
  unknownTitle: "Something went wrong on our side",
  unknownDescription: "Try again in a moment.",
  validationTitle: "Something you entered isn't valid",
  validationDescription: "Check the fields and try again.",
  signedOutTitle: "You're signed out",
  signedOutDescription: "Sign in again to continue.",
  forbiddenTitle: "You don't have access to this",
  forbiddenDescription: "Ask a workspace admin for access.",
  notFoundTitle: "This page does not exist",
  notFoundDescription: "It may not be built yet in the replica, or the link is out of date.",
  offlineTitle: "We can't reach {product} right now",
  offlineDescription: "Check your connection and try again.",
  rateLimitedTitle: "Too many attempts",
  rateLimitedDescription: "Wait a moment, then try again.",
  payloadTooLargeTitle: "That's too large to send",
  payloadTooLargeDescription: "Try a smaller file or fewer rows.",
  newReleaseTitle: "A new version is available",
  newReleaseDescription: "Reload to get the latest version.",
  newReleaseReload: "Reload",
} as const;

const ES: Translation<BrowserCatalog> = {
  tryAgain: "Reintentar",
  pageDidNotLoad: "Esta página no se cargó",
  appDidNotLoad: "{product} no se cargó",
  reference: "Referencia {reference}",
  unknownTitle: "Algo salió mal de nuestro lado",
  unknownDescription: "Inténtalo de nuevo en un momento.",
  validationTitle: "Algo de lo que ingresaste no es válido",
  validationDescription: "Revisa los campos e inténtalo de nuevo.",
  signedOutTitle: "Cerraste sesión",
  signedOutDescription: "Inicia sesión de nuevo para continuar.",
  forbiddenTitle: "No tienes acceso a esto",
  forbiddenDescription: "Pide acceso a un administrador del espacio de trabajo.",
  notFoundTitle: "Esta página no existe",
  notFoundDescription: "Puede que aún no esté construida en la réplica, o que el enlace esté desactualizado.",
  offlineTitle: "No podemos conectar con {product} ahora",
  offlineDescription: "Revisa tu conexión e inténtalo de nuevo.",
  rateLimitedTitle: "Demasiados intentos",
  rateLimitedDescription: "Espera un momento y vuelve a intentarlo.",
  payloadTooLargeTitle: "Es demasiado grande para enviarlo",
  payloadTooLargeDescription: "Prueba con un archivo más pequeño o con menos filas.",
  newReleaseTitle: "Hay una nueva versión disponible",
  newReleaseDescription: "Recarga para obtener la última versión.",
  newReleaseReload: "Recargar",
};

export const BROWSER_CATALOGS: Catalogs<BrowserCatalog> = { en: EN, es: ES };
